import axios from 'axios'
import store from '../store'

export default axios.create({
    baseURL: 'http://43.136.120.154:9033',
    timeout: 10000
})

// 添加请求拦截器
axios.interceptors.request.use(
  function (config) {
    // 获取当前语言
    const language = store.state.language
    // 根据语言设置locale参数
    const locale = language === 'en' ? 'en' : 'zh-CN'
    
    // 添加locale参数到请求中
    if (config.params) {
      config.params.locale = locale
    } else {
      config.params = { locale }
    }
    
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)


// WEBPACK FOOTER //
// ./src/api/index.js